
    <ng-container *ngIf="init">
      <ng-content></ng-content>
    </ng-container>
  